<template>
    <span v-if="dictObj" :style="dictObj[text + '_dict']?.cssClass">{{multipleRender()}}</span>
    <span v-else>{{ text }}</span>

</template>

<script>
export default {
name: "DictRender",
props: {
    dictObj: {type: Object, required: false},
    text: {type: [String, Number, Array, undefined], required: true, default: ''},
},
methods: {
    multipleRender() {
        if (this.text instanceof Array) {
            let dictLabel = []
            this.text.forEach(item => {
                dictLabel.push(this.dictObj[item + ''])
            })
            return dictLabel.join("，")
        }else{
            let that = this.text.toString()
            if (that) {
                let arrayText = that.split(",")
                let dictLabel = []
                arrayText.forEach(item => {
                    dictLabel.push(this.dictObj[item + ''])
                })
                return dictLabel.join("，")
            }else{
                return
            }
        }

    }
}
}
</script>

<style scoped>

</style>
